import {  useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getarrivals } from "../../store/home/homeAction";
import Card from "../../component/Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import Loader from "../../component/Loader";
import img1 from "../../assets/222.jpeg";
import img2 from "../../assets/3-camera_lockup_white.png";
import img3 from "../../assets/7723324_orig.jpg";
import img4 from "../../assets/Lorex-Camera.png";
import img5 from "../../assets/cm104-1.jpg";
import img6 from "../../assets/essential-xl-v2-right.png";
import { Link } from "react-router-dom";

const Newsletter = () => {
  // const dispatch = useDispatch();
  // const { t } = useTranslation();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { arrivals, loading } = useSelector((state) => state.homeSlicer);

  // useEffect(() => {
  //  if(arrivals?.length === 0){
  //   const promise = dispatch(getarrivals(lan));
  //     return ()=>{
  //       promise.abort();
  //     }}
  // }, [lan, dispatch,arrivals?.length]);


  return (
      
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <div className="newsletter-box">
            <h5 className="uppercase">Subscribe to Receive Our Updates</h5>
            <form>
              <input type="email" className="newsletter-input" placeholder="Your email" />
              <input type="submit" className="newsletter-submit btn btn-md btn-dark" value="subscribe" />
            </form>
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default Newsletter;
